const authState = {
  uid: null,
  name: null,
  email: null,
  phoneNumber: null,
  status: null,
  user_type: null,
  user_role: null,
  auth_provider: null,
  address: null,
  created_by: null,
  subscription: null
};

const loginReducer = (prevState, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...prevState,
        uid: action.uid,
        name: action.name,
        email: action.email,
        phoneCode: action?.phone_code,
        rawPhoneNumber: action?.phone_number,
        phoneNumber: `${action?.phone_code || ""}${action?.phone_number || ""}`,
        status: action.status,
        user_type: action.user_type,
        user_role: action.user_role,
        auth_provider: action.auth_provider || "local",
        address: action.address,
        created_by: action.created_by,
        subscription: action.subscription || null
      };

    case "LOGOUT":
      return {
        ...prevState,
        uid: null,
        name: null,
        email: null,
        phoneCode: null,
        rawPhoneNumber: null,
        phoneNumber: null,
        status: null,
        user_type: null,
        user_role: null,
        auth_provider: null,
        address: null,
        created_by: null,
        subscription: null
      };
    default:
      return prevState;
  }
};

export { authState, loginReducer };
